import React, { FC, PropsWithChildren } from 'react';

import { Flex } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';

const AttachmentFileHandlerItemIconPlaceholder: FC<PropsWithChildren> = ({
  children,
}) => (
  <Flex
    border={`1px solid ${theme.colors.charcoal200}`}
    borderRadius="4px"
    height="48px"
    width="48px"
    overflow="hidden"
    justifyContent="center"
    alignItems="center"
    marginRight="8px"
  >
    {children}
  </Flex>
);

export default AttachmentFileHandlerItemIconPlaceholder;
